/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import useCustomToast from "hooks/useCustomToasts";
import useUsuario from "hooks/useUsuario";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loginAsSuscriptor, logoutAsSuscriptor } from "redux/actions/aLogin";
import { consumirServicioEncirptacion } from "../../api";
import Breadcrumcomponent from "../../components/BreadCrumbMex/BreadCrumb";
import FormCambiarContrasenia from "../../components/FormCambiarContrasenia/FormCambiarContrasenia";
import { validarContraseniaNueva } from "../../components/InputsMex/validaciones";
import Page from "../../components/Page";
import {
  urlCambiarContrasenias,
  urlValidacionesCambioContrasenia,
} from "../../constants/urls";
import { encriptarContrasenia } from "../../utils/Encriptar";
import Loading from "../../wrappers/Loading";

const requiredMsg = "Este campo es obligatorio";

const CambiarContraseniaContainer = ({ dataUsuario, loading, setLoading, history }) => {
  const [showError, setShowError] = useState(false);
  const [validaciones, setValidaciones] = useState(null);
  const usuario = useUsuario();
  const { addSuccessToast, addWarningToast } = useCustomToast();
  const dispatch = useDispatch();

  const getData = async () => {
    setLoading(true);
    if (usuario?.isSuscriptor && usuario?.usu_tipo_usuario !== "usu-suscriptor-sbs") {
      if (usuario?.sesionSuscriptor) {
        const { sesionSuscriptor } = usuario;
        dispatch(loginAsSuscriptor(sesionSuscriptor));
      } else {
        dispatch(logoutAsSuscriptor());
        return history.push("/");
      }
    }
    const { transaccion, validaciones } = await consumirServicioEncirptacion(
      urlValidacionesCambioContrasenia,
      {}
    );

    if (transaccion) {
      setValidaciones(validaciones);
    }

    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const onSubmit = async (data) => {
    const passUno = data.passUno;
    const passDos = data.passDos;

    if (passUno !== passDos) {
      addWarningToast("Ambas contraseñas deben coincidir");

      return;
    }

    setLoading(true);

    const Data = {
      cliCodigoCore: dataUsuario.cliCodigoCore,
      cliPasswordAnterior: encriptarContrasenia(data.passActual),
      cliPasswordNueva: encriptarContrasenia(data.passUno),
      cliPasswordNuevaSinEncriptar: data.passUno,
    };

    const result = await consumirServicioEncirptacion(urlCambiarContrasenias, Data);

    if (result.transaccion === false) {
      result.mensajes.forEach((mensaje) => {
        addWarningToast(mensaje.textTitulo);
      });
    } else {
      addSuccessToast("Su contraseña se ha modificado correctamente");
      history.push("/");
    }

    setLoading(false);
  };

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          {validaciones !== null && (
            <React.Fragment>
              <Breadcrumcomponent
                title='Cambiar Contraseña'
                subtitle='Cambiar Contraseña'
              />

              <div className='row mb-5'>
                <div className='col-12'>
                  <div className='card border rounded-top'>
                    <div className='card-header my-3'>
                      <h3 className='font-mex'>Actualizar Contraseña</h3>
                    </div>
                    <div className='card-body'>
                      <div className='row'>
                        <div className='col-md-6 order-1 order-md-0'>
                          <FormCambiarContrasenia
                            showError={showError}
                            errorMsg={validaciones.msgInvalidContrasenia}
                            onSubmit={onSubmit}
                            names={{
                              actual: {
                                name: "passActual",
                                rules: {
                                  required: requiredMsg,
                                },
                              },
                              uno: {
                                name: "passUno",
                                rules: {
                                  requried: requiredMsg,
                                  validate: validarContraseniaNueva(
                                    validaciones,
                                    setShowError
                                  ),
                                },
                              },
                              dos: {
                                name: "passDos",
                                rules: {
                                  requried: requiredMsg,
                                  validate: validarContraseniaNueva(
                                    validaciones,
                                    setShowError
                                  ),
                                },
                              },
                            }}
                          />
                        </div>
                        {validaciones.msgInformacion && (
                          <div className='col-md-6 order-0 order-md-1  align-self-center'>
                            <div
                              className='alert alert-success mt-4 font-mex'
                              dangerouslySetInnerHTML={{
                                __html: validaciones.msgInformacion,
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </Page>
      </div>
    </Loading>
  );
};

export default CambiarContraseniaContainer;
